/**
 * @generated SignedSource<<4ae925aafdb5a1335f486627ef4e3c92>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedProductTileCarousel_items$data = ReadonlyArray<{
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"FavoritesItem_item" | "FavoritesProvider_item" | "ItemTilesCarousel_items">;
  readonly " $fragmentType": "PdpSharedProductTileCarousel_items";
}>;
export type PdpSharedProductTileCarousel_items$key = ReadonlyArray<{
  readonly " $data"?: PdpSharedProductTileCarousel_items$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedProductTileCarousel_items">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isTrade"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "priceBookName"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PdpSharedProductTileCarousel_items",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "fetchFavorites",
          "value": false
        },
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ItemTilesCarousel_items"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FavoritesItem_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FavoritesProvider_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "522880b4f0ea5615accbfbf266fb0dbc";

export default node;
